var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.categories),function(category){return _c('v-flex',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.$emit('setCategory',category)}}},[_vm._v(_vm._s(category))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }